import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from '@wix/da-shared-react/pkg/GallectionFolderDropdown';

import { AppState } from '../../../../../../../types/store';
import {
  getCurrentlyViewedFolder,
  getFolderTotalDeviationCount,
} from '../../../../../../selectors/gallectionSection';
import { setSelectedFolderId } from '../../../../../../actions/gallectionSection';
import { getFolders } from '../../../../../../selectors/folders';

export type StateProps = Pick<
  Props,
  'folders' | 'foldersDeviationCount' | 'currentFolder'
>;
export type DispatchProps = Pick<Props, 'setSelectedFolderId'>;
export type OwnProps = Without<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const folders = getFolders(state);
  const foldersDeviationCount = folders.reduce((acc, folder) => {
    acc[folder.folderId] = getFolderTotalDeviationCount(state, folder.folderId);
    return acc;
  }, {});

  return {
    folders,
    foldersDeviationCount,
    currentFolder: getCurrentlyViewedFolder(state),
  };
};
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  setSelectedFolderId,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
);
